import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Transmission() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img src="/service/Transmission.jpg" alt="" />

          <div className="hero-content">
            <h1>TRANSMISSION</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">TRANSMISSION</h2>

          <p>
           Advanced power transmission solutions ensure seamless, high-capacity electricity flow across long distances with maximum efficiency and reliability. Engineered with robust infrastructure and cutting-edge technologies, these systems support grid stability, minimize transmission losses and enable uninterrupted power supply. Designed to meet growing energy demands, they strengthen national networks while ensuring scalable, future-ready electrical infrastructure.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}

export default Transmission;
